export default "__VITE_ASSET__C75FM8QF__"